import HeaderPage from "../../components/HeaderPage";
import HexagonComponent from "../../components/HexagonComponent";
import SignupBlock from "../../components/SignupBlock";
import styles from "./signuppage.module.css";

export default function SignupPage() {
  return (
    <div className={`container-fluid ${styles.page}`}>
      <HeaderPage />
      <div className={`row my-5 ${styles.logoandsignupBlock}`}>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-4 ${styles.hexagonlogoContainer}`}
        >
          <HexagonComponent />
        </div>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-3 ${styles.signupContainer}`}
        >
          <SignupBlock />
        </div>
      </div>
    </div>
  );
}
